import SocialSVG from './SocialSVG';

export { type SocialSVGProps } from './SocialSVG';
export default SocialSVG;
